import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://swalih.com";
const AWAY_TITLE = "Where'd you go? 👀";

const DEFAULT = {
    title: "Mohammed Swalih — AI Engineer",
    desc: "AI engineer building RAG chatbots, voice AI agents, and computer-vision systems. Previously an AI intern at Etisalat. Also a UI/UX designer & web developer.",
};

const META = {
    "/": DEFAULT,
    "/wwork": {
        title: "Work — Mohammed Swalih",
        desc: "AI projects and the design & web archive: RAG chatbots, voice AI, computer vision, plus UI/UX case studies.",
    },
    "/about": {
        title: "About — Mohammed Swalih",
        desc: "AI engineer and B.Tech student at IIIT Kottayam. Previously an AI Cognitive Solutions Intern at Etisalat (e&).",
    },
    "/contact": {
        title: "Contact — Mohammed Swalih",
        desc: "Get in touch with Mohammed Swalih — AI engineer. Available for AI roles.",
    },
    "/endview": {
        title: "EndView — AI Interview Platform | Mohammed Swalih",
        desc: "A voice-based AI interview platform: real-time Vapi interviews, Groq-scored feedback, and a recruiter dashboard. Built with Next.js and Firebase.",
    },
    "/medchat": {
        title: "MedChat — RAG Medical Chatbot | Mohammed Swalih",
        desc: "A voice-enabled medical RAG chatbot with grounded, source-cited answers. Built with LangChain, Pinecone, Whisper and Chainlit.",
    },
    "/photoextr": {
        title: "ID Document Intelligence — OCR + MRZ | Mohammed Swalih",
        desc: "A FastAPI service that extracts the portrait, key fields, and MRZ from ID documents for KYC/KYB — OpenCV and EasyOCR.",
    },
    "/fblur": {
        title: "FBlur — Video Face Blur | Mohammed Swalih",
        desc: "Automated privacy protection: detecting and blurring every face in a video with YOLOv10-face, CLAHE and OpenCV.",
    },
    "/prj1": {
        title: "CasaVUE — Case Study | Mohammed Swalih",
        desc: "A luxury real-estate concept — UX research, information architecture, and UI design.",
    },
    "/prj2": {
        title: "scholarKart — Case Study | Mohammed Swalih",
        desc: "A scholarship discovery portal for Indian students — UX research, IA, wireframes, and UI design.",
    },
};

function setTag(selector, create, attr, value) {
    let el = document.head.querySelector(selector);
    if (!el) {
        el = create();
        document.head.appendChild(el);
    }
    el.setAttribute(attr, value);
}

export default function RouteMeta() {
    const { pathname } = useLocation();
    const current = useRef(DEFAULT.title);

    useEffect(() => {
        const m = META[pathname] || DEFAULT;
        const url = SITE + (pathname === "/" ? "/" : pathname);

        current.current = m.title;
        document.title = m.title;

        setTag('meta[name="description"]',
            () => Object.assign(document.createElement("meta"), { name: "description" }),
            "content", m.desc);

        setTag('link[rel="canonical"]',
            () => Object.assign(document.createElement("link"), { rel: "canonical" }),
            "href", url);

        setTag('meta[property="og:title"]',
            () => { const e = document.createElement("meta"); e.setAttribute("property", "og:title"); return e; },
            "content", m.title);

        setTag('meta[property="og:description"]',
            () => { const e = document.createElement("meta"); e.setAttribute("property", "og:description"); return e; },
            "content", m.desc);

        setTag('meta[property="og:url"]',
            () => { const e = document.createElement("meta"); e.setAttribute("property", "og:url"); return e; },
            "content", url);

        setTag('meta[name="twitter:title"]',
            () => Object.assign(document.createElement("meta"), { name: "twitter:title" }),
            "content", m.title);

        setTag('meta[name="twitter:description"]',
            () => Object.assign(document.createElement("meta"), { name: "twitter:description" }),
            "content", m.desc);
    }, [pathname]);

    // "Where'd you go?" — swap the tab title while the tab is hidden.
    useEffect(() => {
        const onVisibility = () => {
            document.title = document.hidden ? AWAY_TITLE : current.current;
        };
        document.addEventListener("visibilitychange", onVisibility);
        return () => document.removeEventListener("visibilitychange", onVisibility);
    }, []);

    return null;
}
